module.exports = __webpack_public_path__ + "img/contact-logo.985308e6.png";